
import {useState, useEffect} from 'react';
import {
    PRODUCT_TYPE_ISA,
    PRODUCT_TYPE_DESCRIPTIONS,
    PRODUCT_TYPE_LISA,
    PRODUCT_TYPE_JISA,
    PRODUCT_TYPE_JSIPP,
    PRODUCT_TYPE_SIPP,
    PRODUCT_TYPE_DEALING
} from 'src/Accounts';
import { 
    COMPLEX_INSTRUMENT,
    INSTRUMENT_TYPE_SHARE,
    INSTRUMENT_TYPE_FUND,
    INSTRUMENT_TYPE_ETF,
    INSTRUMENT_TYPE_INVESTMENT_TRUST
} from 'src/Api';

export default function TradableProducts({instrument}) {

    const linkStyles = "darkblue-500-text text-transform-none inline-block text-underline-none font-weight-bold";

    const displayInvestmentText = () => {
        if (instrument.tradable.ri || instrument.tradable.dripable) {
            return <>
                and can be used with&nbsp;
                    {
                        instrument.tradable.ri && instrument.tradable.dripable ? (
                            <>
                                <a className={linkStyles} href="/platform/regularinvestments" target="_blank" rel="noreferrer" data-testid="regularInvestmentText1">Regular investment</a>
                                &nbsp;and&nbsp;
                                <a className={linkStyles} href="/platform/drips" target="_blank" rel="noreferrer" data-testid="dividendReinvestmentText1">Dividend reinvestment</a>
                            </>
                        ) : (instrument.tradable.ri ? (
                            <a className={linkStyles} href="/platform/regularinvestments" target="_blank" rel="noreferrer" data-testid="regularInvestmentText2">Regular investment</a>
                        ) : (
                            <a className={linkStyles} href="/platform/drips" target="_blank" rel="noreferrer" data-testid="dividendReinvestmentText2">Dividend reinvestment</a>
                        ))
                    } 
            </>
        }

        return null;
    }

    const displayInstrumentTypeLabel = () => {
        switch (instrument.type) {
            case INSTRUMENT_TYPE_FUND:
                return <>fund</>
            case INSTRUMENT_TYPE_SHARE:
            case INSTRUMENT_TYPE_ETF:
            case INSTRUMENT_TYPE_INVESTMENT_TRUST:
                return <>share</>
            default:
                return <>stock</>
        }
    }

    const displayProductLink = (productType) => {
        switch (productType) {
            case PRODUCT_TYPE_ISA:
                return '/isa/stocks-shares-isa'
            case PRODUCT_TYPE_SIPP:
                return '/pensions/sipp'
            case PRODUCT_TYPE_JISA:
                return '/investing-for-children/junior-isa'
            case PRODUCT_TYPE_JSIPP:
                return '/investing-for-children/junior-sipp'
            case PRODUCT_TYPE_LISA:
                return '/lifetime-isa'
            case PRODUCT_TYPE_DEALING:
                return '/dealing-account'
            default:
                return
        }
    }
        
    const renderTradable = () => {

        if(instrument && instrument.tradable && instrument.tradable.tradableProducts) {
            const allowedProducts = [];

            for(let product in instrument.tradable.tradableProducts) {
                if(instrument.tradable.tradableProducts[product]) {
                    const productType = parseInt(product.split("-")[1]);                    

                    if ([PRODUCT_TYPE_ISA, PRODUCT_TYPE_JISA, PRODUCT_TYPE_SIPP, PRODUCT_TYPE_JSIPP].includes(productType) && !instrument.figaroData) {
                        continue;
                    }

                    if ([PRODUCT_TYPE_ISA, PRODUCT_TYPE_JISA].includes(productType)  && !instrument.figaroData.isaEligibility) {
                        continue;
                    }

                    if ([PRODUCT_TYPE_SIPP, PRODUCT_TYPE_JSIPP].includes(productType) && !instrument.figaroData.sippEligibility) {
                        continue;
                    }

                    if ([PRODUCT_TYPE_JISA, PRODUCT_TYPE_JSIPP].includes(productType) && instrument.complex === COMPLEX_INSTRUMENT) {
                        continue;
                    }

                    allowedProducts.push(productType);

                    if (productType === PRODUCT_TYPE_ISA) {
                        allowedProducts.push(PRODUCT_TYPE_LISA);
                    }
                }
            }

            // Make sure LISA isn't included twice
            const filteredAllowedProducts = allowedProducts.filter((x, i, a) => a.indexOf(x) == i)

            if (instrument.tradable && instrument.tradable.tradable && filteredAllowedProducts && filteredAllowedProducts.length > 0) {
                return <p className="block margin-0 max-characters-none inline-block h7">
                    This {displayInstrumentTypeLabel()} can be held in a&nbsp;
                    {
                        filteredAllowedProducts.map(productNum => {
                            return (
                                <a key={productNum} className={linkStyles + " margin-right-10"} href={displayProductLink(productNum)} rel="noreferrer" target="_blank" data-testid={`heldInvestment${productNum}`}>
                                    <i className="fas fa-check green-500-text padding-right-5"></i>
                                    {PRODUCT_TYPE_DESCRIPTIONS[productNum]}
                                </a> 
                            )
                        })
                    }
                    {displayInvestmentText()}
                </p>
            }
        } else {
            return null;
        }
    }

    return (
        <>
            {renderTradable()}
        </>
    );

}